import type { FlashOfferRoomDraft } from '../RoomsStep/utils';

export interface RoomRateRoom {
  id: string;
  name: string;
  hasRatePlan: boolean;
}

type RoomRateSource = Pick<App.RoomType, 'id' | 'name'> & {
  room_rates?: Array<{ rate_plan?: { id?: string | null } | null }>;
};

type BuildRoomRateRoomsParams = {
  appliedRoomTypeIds?: Array<string>;
  ratePlanId?: string;
  roomDrafts: Array<FlashOfferRoomDraft>;
  roomTypes: Array<RoomRateSource>;
};

export function buildRoomRateRooms({
  appliedRoomTypeIds = [],
  ratePlanId,
  roomDrafts,
  roomTypes,
}: BuildRoomRateRoomsParams) {
  const roomsById = new Map<string, RoomRateRoom>();
  const appliedRoomTypeIdSet = new Set(appliedRoomTypeIds);

  roomTypes.forEach((roomType) => {
    if (!roomType.id) {
      return;
    }

    roomsById.set(roomType.id, {
      id: roomType.id,
      name: roomType.name || roomType.id,
      hasRatePlan:
        appliedRoomTypeIdSet.has(roomType.id) ||
        (!!ratePlanId && (roomType.room_rates ?? []).some((rate) => rate.rate_plan?.id === ratePlanId)),
    });
  });

  roomDrafts.forEach((roomDraft) => {
    if (!roomDraft.id || roomsById.has(roomDraft.id)) {
      return;
    }

    roomsById.set(roomDraft.id, {
      id: roomDraft.id,
      name: roomDraft.existingRoomName || roomDraft.name || roomDraft.id,
      hasRatePlan: appliedRoomTypeIdSet.has(roomDraft.id),
    });
  });

  return Array.from(roomsById.values());
}
